import React from 'react';
import type { TopBannerProps } from '@noths/polaris-client-banners';
import { TopBanner } from '@noths/polaris-client-banners';
import type { NavigationProps } from '@noths/polaris-client-site-chrome-ui';
import {
  createSiteChromeStaticContextProvider,
  Footer,
  GlobalNavigation,
  Header,
  Navigation,
  SiteChromeDynamicContextProvider,
} from '@noths/polaris-client-site-chrome-ui';
import cookies from 'js-cookie';

import type { SiteChromeLayoutComponentProps } from '../types';

const appSelector = '#NOTHSPageWrapper';
const SiteChromeStaticContextProvider = createSiteChromeStaticContextProvider(appSelector);

export const ClientSiteChromeUI = ({
  children,
  featureFlags = {},
  isProdLikeEnv,
  mergeBasket,
  navData,
  searchedTerm,
  siteChromeCompactMode = false,
  topBannerData,
}: SiteChromeLayoutComponentProps) => {
  const siteChromeEnv = isProdLikeEnv ? 'production' : 'qa';
  const globalNavigation =
    featureFlags[GlobalNavigation.NAME] === GlobalNavigation.PROGRESSIVE_DISCLOSURE
      ? GlobalNavigation.PROGRESSIVE_DISCLOSURE
      : GlobalNavigation.LEGACY;

  return (
    <SiteChromeStaticContextProvider
      compact={siteChromeCompactMode}
      cookies={cookies}
      env={siteChromeEnv}
      globalNavigation={globalNavigation}
      mergeBasket={mergeBasket}
      searchedTerm={searchedTerm}
    >
      <SiteChromeDynamicContextProvider>
        <>
          {topBannerData && <TopBanner {...(topBannerData as TopBannerProps)} />}
          <Header />
          {navData && <Navigation {...(navData as NavigationProps)} />}
          <main role="main">{children}</main>
          <Footer />
        </>
      </SiteChromeDynamicContextProvider>
    </SiteChromeStaticContextProvider>
  );
};
